export default from './Payments';



// WEBPACK FOOTER //
// ./src/containers/Payments/index.js